import * as React from 'react';
import { SliderWrapper, SliderActive, SliderButton } from './styles';

interface Props {
  items: string[];
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<any>>;
  isMobile?: boolean;
}

interface GetPartyAbbreviation {
  (partyName: string): string;
}

const getPartyAbbreviation: GetPartyAbbreviation = (partyName) => {
  switch (partyName) {
    case 'Democrat':
      return 'DEM';
    case 'Republican':
      return 'REP';
    default:
      return partyName;
  }
};

const Slider: React.FC<React.PropsWithChildren<Props>> = ({ items, activeTab, setActiveTab }) => {
  const tabs = items.length;

  return (
    <SliderWrapper>
      {activeTab >= 0 && <SliderActive tabs={tabs} activeTab={activeTab} />}
      {items.map((item, i) => {
        const abbreviation = getPartyAbbreviation(item);
        return (
          <SliderButton
            key={item}
            tabs={tabs}
            activeTab={activeTab}
            onClick={() => setActiveTab(i)}
          >
            <span className="hidden md:inline">{item}</span>
            <span className="inline md:hidden">{abbreviation}</span>
          </SliderButton>
        );
      })}
    </SliderWrapper>
  );
};

export default Slider;
